import { useEffect, useRef, useState } from 'react';
import FlightSingleInfoRow from './FlightSingleInfoRow';

const DeferredSingleFlightInfoRow = ({ flight, kind }) => {
  const [isVisible, setIsVisible] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    if (rowRef.current) {
      observer.observe(rowRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={rowRef}>
      {isVisible ? (
        <FlightSingleInfoRow flight={flight} kind={kind} />
      ) : (
        <div className="h-32 animate-pulse bg-gray-100 rounded-lg" /> // Placeholder con efecto de carga
      )}
    </div>
  );
};

export default DeferredSingleFlightInfoRow;
